module.exports = __webpack_public_path__ + "img/VideoMail.419ecc8d.png";